import React, { useState, useEffect } from "react";
import {
  Container,
  Grid,
  Select,
  MenuItem,
  CircularProgress,
  FormControl,
  InputLabel,
  Button,
} from "@mui/material";
import { useStateContext } from "../context/ContextProvider";
import axiosClient from "../axiosClient";

const ChangeVatUtilComponent = ({ setMessage }) => {
  const [vats, setVats] = useState([]);
  const [loading, setLoading] = useState(false);
  const { store } = useStateContext();

  const [selectedVatToChange, setSelectedVatToChange] = useState();
  const [selectedVatToChangeTo, setSelectedVatToChangeTo] = useState();
  const [selectedPrice, setSelectedPrice] = useState();

  useEffect(() => {
    setLoading(true);
    const correctStoreName = JSON.parse(store).name.replace(/[^a-zA-Z]/g, "");
    const databaseStoreName = `DB301_${
      JSON.parse(store).id
    }_${correctStoreName}`;

    axiosClient
      .get(`vats/${databaseStoreName}`)
      .then((response) => {
        setVats(response.data.data);
        setLoading(false);
      })
      .catch((err) => console.log(err));
  }, [store]);

  if (loading) {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <CircularProgress />
        </Grid>
      </Grid>
    );
  }

  return (
    <Container>
      <Grid container spacing={2}>
        <Grid item lg={3} xs={12}>
          <FormControl fullWidth>
            <InputLabel>Vat to change</InputLabel>
            <Select
              fullWidth
              onChange={(e) => setSelectedVatToChange(e.target.value)}
            >
              {vats.map((option, index) => (
                <MenuItem key={option.id} value={option.id}>
                  {option.vat}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item lg={3} xs={12}>
          <FormControl fullWidth>
            <InputLabel>Vat to change to</InputLabel>
            <Select
              fullWidth
              onChange={(e) => setSelectedVatToChangeTo(e.target.value)}
            >
              {vats.map((option, index) => (
                <MenuItem key={option.id} value={option.id}>
                  {option.vat}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item lg={3} xs={12}>
          <FormControl fullWidth>
            <InputLabel>Price</InputLabel>
            <Select
              fullWidth
              onChange={(e) => setSelectedPrice(e.target.value)}
            >
              <MenuItem key={0} value={"price_one"}>
                Price one
              </MenuItem>
              <MenuItem key={1} value={"price_two"}>
                Price two
              </MenuItem>
              <MenuItem key={1} value={"both"}>
                Both
              </MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid container lg={3} xs={12} justifyContent="flex-end">
          <Button
            type="submit"
            variant="contained"
            color="success"
            onClick={() => {
              if (selectedVatToChange === selectedVatToChangeTo || selectedPrice===null || selectedVatToChange==null || selectedVatToChangeTo==null) {
                //do nothing
              } else {
                const correctStoreName = JSON.parse(store).name.replace(
                  /[^a-zA-Z]/g,
                  ""
                );
                const databaseStoreName = `DB301_${
                  JSON.parse(store).id
                }_${correctStoreName}`;

                const payload = {
                  shopName: databaseStoreName,
                  vat_change_id: selectedVatToChange,
                  vat_change_to_id: selectedVatToChangeTo,
                  price_to_change: selectedPrice,
                };
                axiosClient
                  .patch("products/changeVats", payload)
                  .then((response) => setMessage(response.data.message))
                  .catch((err) => console.log(err));
              }
            }}
          >
            Change
          </Button>
        </Grid>
      </Grid>
    </Container>
  );
};

export default ChangeVatUtilComponent;
